export const handleInvalidUrl = async () => {
    const redirectRoute = await useRedirect();
    const invalidUrlOptions = {
        external: true,
    };
    return { redirectRoute, invalidUrlOptions };
};
